import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Router from 'bcl/router';

export default class AuthBasicDataItemRoute extends Route {
  @service declare store: Store;
  @service declare router: Router;
  model(params: { id: string }) {
    if (params.id == 'null') {
      this.router.transitionTo('auth.basic-data');
      return;
    }
    return this.store.peekRecord('item', params.id);
  }
}
